import RouteService from "@/services/RouteService";
import MainHeader from "@/components/MainHeader.vue";
import SettingsSaveBar from "@/components/SettingsSaveBar.vue";
export default {
  name: 'UserTasks',
  props: {
    rootScope: {
      type: Object,
      required: true
    }
  },
  components: {
    MainHeader,
    SettingsSaveBar
  },
  data() {
    return {
      tasks: [],
      currentTask: {},
      isProcessing: false,
      unsaved: false
    };
  },
  async mounted() {
    this.tasks = (await this.leanLawApi.listTasks()).tasks;
    this.routeService = new RouteService(this);
    const deactivate = this.routeService.rootScopeChange().$on("$stateChangeStart", event => {
      if (this.showButtonGroup) {
        this.unsaved = true;
        setTimeout(() => {
          this.unsaved = false;
        }, 4000);
        event.preventDefault();
      } else {
        deactivate();
      }
    });
  },
  computed: {
    isSubmitButtonDisabled() {
      return !this.currentTask?.label?.trim() || this.isProcessing;
    },
    showButtonGroup() {
      return this.currentTask?.isEditing || this.currentTask?.label || this.currentTask?.shortCode;
    },
    formActionHeader() {
      return (this.currentTask?.isEditing ? 'Edit' : 'Add New') + ' Snippet';
    }
  },
  methods: {
    async upsertTask() {
      try {
        this.isProcessing = true;
        if (this.currentTask.id) {
          // update
          const updated = await this.leanLawApi.updateTask({
            id: this.currentTask.id,
            body: this.currentTask
          });
          this.tasks = this.tasks.map(t => t = t.id === updated.id ? updated : t);
          this.alerts.success('Your settings were saved.');
        } else {
          // create a new one
          const added = await this.leanLawApi.createTask({
            body: this.currentTask
          });
          this.tasks.push(added);
          this.alerts.success('Your settings were saved.');
        }
        this.currentTask = {};
      } catch (err) {
        this.alerts.error(err);
      } finally {
        this.isProcessing = false;
      }
    },
    async removeTask(task) {
      if (this.isProcessing) return;
      try {
        await this.leanLawApi.deleteTask({
          id: task.id
        });
        this.tasks = this.tasks.filter(t => t.id !== task.id);
        this.alerts.success('Your settings were saved.');
      } catch (err) {
        this.alerts.error(err);
      } finally {
        this.isProcessing = false;
      }
    },
    setCurrentTask(task) {
      if (this.isProcessing) return;
      if (task !== null) {
        task.isEditing = true;
      } else {
        let currentTask = this.tasks.find(t => t.id === this.currentTask.id);
        if (currentTask) currentTask.isEditing = false;
      }
      this.currentTask = {
        ...task
      };
    }
  }
};